/* eslint import/no-extraneous-dependencies: 0 */
/* eslint no-underscore-dangle: 0 */
/* eslint max-classes-per-file: 0 */
import * as Blockly from 'blockly/core';
import './toolboxCategory.scss';

/**
 * Clases de la v11 (`blocklyTree*`) que el SCSS del shell (App.scss,
 * BlocklyPanel.scss) usa y que la v13 renombró. Se traducen acá vía `cssConfig`;
 * también se repone el icono de `iconclass`/`expandedclass`, que la v13 no lee.
 */
const LEGACY_CSS = {
  container: 'blocklyToolboxCategoryContainer',
  row: 'blocklyTreeRow',
  rowcontentcontainer: 'blocklyTreeRowContentContainer',
  icon: 'blocklyTreeIcon',
  label: 'blocklyTreeLabel',
  contents: 'blocklyToolboxCategoryGroup',
  selected: 'blocklyTreeSelected',
  openicon: 'blocklyTreeIcon',
  closedicon: 'blocklyTreeIcon',
};

// Una categoría colapsable usa SIEMPRE la `expandedclass`, abierta o cerrada, como
// en prod: el CSS del shell solo define el punto de modo texto para esa clase.
const cssConfigFor = (def = {}, collapsible = false) => {
  const iconOf = (cls) => (cls ? `${LEGACY_CSS.icon} ${cls}` : LEGACY_CSS.icon);
  const leafClass = iconOf(def.iconclass);
  const expandedClass = def.expandedclass ? iconOf(def.expandedclass) : leafClass;
  const iconClass = collapsible ? expandedClass : leafClass;
  return {
    ...LEGACY_CSS,
    icon: iconClass,
    openicon: expandedClass,
    closedicon: iconClass,
  };
};

// El punto de color del modo texto es un tercer span vacío que el shell pinta
// (`.blocklyTreeIcon + span + span` en App.scss); la v13 no lo genera.
const appendLegacyDotSpan = (category) => {
  const contents = category.rowContents_;
  if (!contents) return;
  contents.appendChild(document.createElement('span'));
};

export class EducabotToolboxCategory extends Blockly.ToolboxCategory {
  makeDefaultCssConfig_() {
    return cssConfigFor(this.toolboxItemDef_);
  }

  addColourBorder_() {
    // Sin la franja de color de Zelos: la v13 la pinta inline y el CSS no la tapa.
  }

  createDom_() {
    const dom = super.createDom_();
    appendLegacyDotSpan(this);
    return dom;
  }
}

export class EducabotCollapsibleToolboxCategory extends Blockly.CollapsibleToolboxCategory {
  makeDefaultCssConfig_() {
    return cssConfigFor(this.toolboxItemDef_, true);
  }

  addColourBorder_() {
    // Sin franja: ver EducabotToolboxCategory.
  }

  createDom_() {
    const dom = super.createDom_();
    appendLegacyDotSpan(this);
    return dom;
  }

  // Se ignora a propósito el `expanded="true"` de los perfiles: en prod la
  // categoría siempre arranca colapsada.
  init() {
    super.init();
    this.setExpanded(false);
  }
}

// El FocusManager de la v13 cierra el flyout cuando la ventana pierde el foco
// (cambio de pestaña, alt-tab); en prod sigue abierto. Si el foco se movió dentro
// de la página (`document.hasFocus()`), Blockly decide como siempre.
export class EducabotToolbox extends Blockly.Toolbox {
  onTreeBlur(nextTree) {
    if (!document.hasFocus()) return;
    super.onTreeBlur(nextTree);
  }
}

// El true final es el override: las dos categorías y el toolbox ya están
// registrados por Blockly con estos mismos nombres.
Blockly.registry.register(
  Blockly.registry.Type.TOOLBOX_ITEM,
  Blockly.ToolboxCategory.registrationName,
  EducabotToolboxCategory,
  true,
);

Blockly.registry.register(
  Blockly.registry.Type.TOOLBOX_ITEM,
  Blockly.CollapsibleToolboxCategory.registrationName,
  EducabotCollapsibleToolboxCategory,
  true,
);

Blockly.registry.register(
  Blockly.registry.Type.TOOLBOX,
  'default',
  EducabotToolbox,
  true,
);

// Scopes de la v11 que usa el SCSS del shell y no salen del cssConfig. Arranca
// en `-text` porque es el estado inicial del shell, que después hace el swap a `-icons`.
export const applyLegacyToolboxClasses = (workspace) => {
  const toolbox = workspace?.getToolbox?.();
  const root = toolbox?.HtmlDiv;
  if (!root) return;
  root.classList.add('blocklyToolboxDiv');
  root.classList.add('blocklyToolboxDiv-text');
  const contents = root.querySelector('.blocklyToolboxCategoryGroup');
  if (contents) contents.classList.add('blocklyTreeRoot');
};

// Papelera propia dibujada con CSS (`.toolboxTrashcan` en toolboxCategory.scss);
// el trashcan SVG de Blockly está desactivado. Va con `insertAdjacentHTML`: con
// `innerHTML +=` se re-parsea el subárbol y se desconectan las categorías colapsables.
// La v13 solo marca el borrado con el puntero sobre el toolbox; el gris de "armado"
// durante todo el arrastre lo pone armTrashcanOnBlockDrag con una clase propia.
const TOOLBOX_TRASHCAN_MARKUP = `
  <div class="toolboxTrashcan">
    <div class="trash-parent">
      <span class="trash">
        <span></span>
        <i></i>
      </span>
    </div>
  </div>`;

export const injectToolboxTrashcan = (workspace) => {
  const toolbox = workspace?.getToolbox?.();
  const root = toolbox?.HtmlDiv;
  const contents = root?.querySelector('.blocklyToolboxCategoryGroup');
  if (!contents || contents.querySelector(':scope > .toolboxTrashcan')) return;
  contents.insertAdjacentHTML('beforeend', TOOLBOX_TRASHCAN_MARKUP);
};

export const armTrashcanOnBlockDrag = (workspace) => (event) => {
  if (event.type !== Blockly.Events.BLOCK_DRAG) return;
  const toolbox = workspace?.getToolbox?.();
  const root = toolbox?.HtmlDiv;
  if (!root) return;

  if (!event.isStart) {
    root.classList.remove('blocklyToolboxTrashArmed');
    return;
  }
  const block = workspace.getBlockById(event.blockId);
  if (block && block.isDeletable()) root.classList.add('blocklyToolboxTrashArmed');
};
